import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Templates from './templates'
import axios from 'axios'
import DatetimePicker from 'vuetify-datetime-picker'

import '@mdi/font/css/materialdesignicons.css'


axios.defaults.withCredentials = true;

(async () => {
  await store.dispatch('user_request')

  Vue.use(Templates)

  Vue.config.productionTip = false

  Vue.use(DatetimePicker)

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})()